<script>
    export let title = 'Page';
</script>

<h2>{title} not found</h2>

<style>
    h2  {
        text-align: center;
        padding-top: 25%;
    }
</style>